import log from 'salvo-lite/log'
import axios from 'axios'
import ProductForm from './ProductForm'

class Cart {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._currency = JSON.parse(elem.getAttribute('data-currency'))
        this._quantitySelectors = document.querySelectorAll('[data-quantity-selector]')
        this._removers = document.querySelectorAll('[data-remove-item]')
        this._subtotal = document.querySelector('[data-subtotal]')
        this._clearBag = document.querySelector('.side-cart--clear')
        this._itemsIncrementer = document.querySelector('#cart-items')
        this._menuItemsIncrementer = document.querySelectorAll('.user-menu__bag__counter')
        this._idleTimer = null
        this._itemsContainer = document.querySelector('.cart__items-container')

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const div = document.createElement('div')
        div.setAttribute('data-product-form', '{}')
        div.setAttribute('data-currency', JSON.stringify(this._currency))

        if (window.location.pathname !== '/cart') {
            const initSideCart = new ProductForm(this._theme, div)
            initSideCart.buildSideCart()
        }

        this.initQuantitySelectors()

        this.initRemovers()

        if (this._clearBag) {
            this._clearBag.addEventListener('click', () => this.clear())
        }
    }

    initQuantitySelectors () {
        this._quantitySelectors.forEach(selector => {
            const quantityField = selector.querySelector('[name="quantity"]')
            const updateID = selector.getAttribute('data-quantity-selector')

            selector.querySelector('[data-minus]').addEventListener('click', () => {
                if (parseInt(quantityField.value) - 1 === 0) {
                    const removeItem = selector.closest('.cart__item-card')
                    setTimeout(() => removeItem.parentElement.removeChild(removeItem), 500)
                }

                quantityField.value = parseInt(quantityField.value) - 1
                this.delayUpdate(updateID, quantityField.value)
            })

            selector.querySelector('[data-plus]').addEventListener('click', () => {
                quantityField.value = parseInt(quantityField.value) + 1
                this.delayUpdate(updateID, quantityField.value)
            })
        })
    }

    initRemovers () {
        this._removers.forEach(remover => {
            const updateID = remover.getAttribute('data-remove-item')

            remover.addEventListener('click', () => {
                this.delayUpdate(updateID, 0)
            })
        })
    }

    delayUpdate (id, qty) {
        clearTimeout(this._idleTimer)
        this._idleTimer = setTimeout(() => this.updateCart(id, qty), 500)
    }

    async updateCart (id, qty, sideCart) {
        const res = await axios.post('/cart/update.js', 'updates[' + id + ']=' + qty)

        const dollarAmount = (res.data.total_price / 100).toLocaleString() + '.00'
        if (this._currency.position === 'front') {
            this._subtotal.innerHTML = this._currency.symbol + dollarAmount
        } else {
            this._subtotal.innerHTML = dollarAmount + this._currency.symbol
        }

        const emptyCartText = document.querySelector('.empty-cart-text')

        if (qty === 0) {
            const items = res.data.items.map(item => item.id)

            if (items.length === 0) {
                document.querySelectorAll('.cart__item-card').forEach(item => {
                    this._itemsContainer.removeChild(item)
                })

                emptyCartText.classList.add('active')

                if (this._itemsIncrementer) {
                    this._itemsIncrementer.innerHTML = 0
                }

                if (this._menuItemsIncrementer.length > 0) {
                    this._menuItemsIncrementer.forEach(element => {
                        element.innerHTML = 0
                    })
                }

                if (window.location.pathname === '/cart') {
                    document.querySelector('.cart__container').classList.add('visually-hidden')
                }

                return
            } else {
                const oldItems = document.querySelectorAll('.cart__item-card')
                oldItems.forEach(item => {
                    if (!items.includes(parseInt(item.id))) {
                        this._itemsContainer.removeChild(item)
                    }
                })
            }
        }

        if (this._itemsIncrementer) {
            this._itemsIncrementer.innerHTML = res.data.item_count
        }

        if (this._menuItemsIncrementer.length > 0) {
            this._menuItemsIncrementer.forEach(element => {
                element.innerHTML = res.data.item_count
            })
        }

        if (res.data.item_count === 0) {
            emptyCartText.classList.add('active')
        }
    }

    async clear () {
        try {
            await axios.get('/cart/clear')
            document.querySelectorAll('.cart__item-card').forEach(item => {
                this._itemsContainer.removeChild(item)
            })
            let emptyCartText = document.querySelector('.empty-cart-text')
            emptyCartText.classList.add('active')
            if (this._itemsIncrementer) {
                this._itemsIncrementer.innerHTML = 0
            }
            if (this._menuItemsIncrementer.length > 0) {
                this._menuItemsIncrementer.forEach(element => {
                    element.innerHTML = 0
                })
            }
            this._subtotal.innerHTML = this._currency.symbol + '0.00'
            document.querySelector('.side-cart').classList.remove('show')
        } catch (error) {
            console.log(error)
        }
    }
}

export default Cart



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Cart.js